import { Link } from 'react-router-dom'
import is from 'is_js'

export default function CevLink({ title, path, index, gif, setHovered }) {
  return (
    <Link 
      to={ `/closed-eye-visual/${ path }` }
      onMouseEnter={ () => setHovered(gif) }
      onMouseLeave={ () => setHovered('') }
      className='indent'>
      { is.number(index) ? `${ index + 1 }.` : '' } { title }
    </Link>
  )
}